import { ReportRecord } from '../../../../../models/report.model';
import { TemplateFieldsDisplayFn } from '../../../../../models/template.model';
import { displayFnWrapper } from '../../../utils/dynamic-data-retrievers';
import { PropertyType, propertyTypeDisplayFnFactory } from '../us.common';
import {
  getFloorSuiteVals,
  US_AVAILABILITY_COMMON_BODY_FIELDS,
  US_AVAILABILITY_COMMON_FOOTER_FIELDS,
  US_AVAILABILITY_COMMON_HEADER_FIELDS,
} from './us-availability.common';

const retailDisplayFnWrapper = propertyTypeDisplayFnFactory(PropertyType.Retail);

export const displayFnMap: TemplateFieldsDisplayFn = {
  ...US_AVAILABILITY_COMMON_HEADER_FIELDS(PropertyType.Retail),
  ...US_AVAILABILITY_COMMON_BODY_FIELDS(PropertyType.Retail),
  ...US_AVAILABILITY_COMMON_FOOTER_FIELDS,
  165: { displayFn: displayFnWrapper }, // 165 - Floors
  191: {
    displayFn: (record: ReportRecord, _, suite, floor) => {
      const result = getFloorSuiteVals(record, floor, suite);
      return result;
    },
  }, // 191 - Floor | Suite
  219: { displayFn: retailDisplayFnWrapper }, // 219 - Anchor Tenant Note
};
